import { Container, Grid } from '@mui/material';
import { useEffect } from 'react';

export default function NextPatientADHDWidget() {
  useEffect(() => {
    const scriptId = 'nextpatient-provider-locations-script';
    // Prevent duplicate script loading
    if (!document.getElementById(scriptId)) {
      const script = document.createElement('script');
      script.id = scriptId;
      script.src = 'https://nextpatient.co/p/6380/70571/provider-locations.js?id=70571';
      script.async = true;
      document.body.appendChild(script);
    }

    return () => {
      // Optional cleanup (usually not required unless remounting often)
      const widget = document.getElementById('nextpatient-widget.70571');
      if (widget) {
        widget.innerHTML = '';
      }
    };
  }, []);

  return (
    <Container maxWidth='lg'>
      <Grid item sx={{ mt: 4, mb: 4 }} justifyContent={'center'} display={'flex'}>
        <div>
          {/* ADHD Testing */}
          <div id='nextpatient-widget.70571' />
        </div>
      </Grid>
    </Container>
  );
}
